var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFr = function SvgFr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fr_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fr_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CE1126",
    d: "M-5 0h29v19H-5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 0h7v19H6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002654",
    d: "M-5 0H6v19H-5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fr_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "#fff",
    rx: 9.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fr_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-5 0h29v19H-5z"
  })))));
};
export default SvgFr;